import type { CustomIconProps } from '../CustomIcon';

export function Finish(props: CustomIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="2348.46 57.13 360 360" {...props}>
      <path
        strokeMiterlimit={10}
        fill="none"
        d="M2528.45,60.13c-97.75,0-176.99,79.24-176.99,176.99s79.24,176.99,176.99,176.99,176.99-79.24,176.99-176.99-79.24-176.99-176.99-176.99M2528.45,65.54c94.61,0,171.58,76.97,171.58,171.58s-76.97,171.58-171.58,171.58-171.58-76.97-171.58-171.58,76.97-171.58,171.58-171.58"
      />
      <line strokeLinecap="round" fill="none" x1="2448.18" y1="115.35" x2="2448.18" y2="365.95" />
      <path
        strokeLinecap="round"
        fill="none"
        d="M2672.52,280.68s-37.74,5.39-56.61-24.26c-18.87-29.65-35.04-67.38-67.38-83.55-32.34-16.17-92.28-56.61-80.86-35.04,11.42,21.56,107.82,88.95,91.65,110.51-10.78,13.47-22.91-9.44-37.74-22.91-11.64-10.31-45.82-22.93-14.82,11.7,40.43,50.3,32.34,85.34,114.55,105.55"
      />
      <path
        strokeLinecap="round"
        fill="none"
        d="M2495.11,167.28s-25.26-10.39-16.46,7.13c9.72,16.46,30.01,12.91,51.5,24.54"
      />
      <path
        strokeLinecap="round"
        fill="none"
        d="M2552.57,225.43s-21.96-14.69-47.72-20.82c-25.77-6.13-21.2-18.46-13.11-18.46"
      />
    </svg>
  );
}
